var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        no: "dialog",
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.CustomsDeclarationInfo"),
        width: _vm.$selectByLang("240px", "300px"),
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          staticStyle: { margin: "0 10px" },
          attrs: {
            "label-width": _vm.$selectByLang("60px", "120px"),
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("queryJob.declared") } },
            [
              _c("el-checkbox", {
                attrs: { no: "1", value: _vm.aeJob.declareCustomsState === 1 },
                on: {
                  input: function(value) {
                    _vm.aeJob.declareCustomsState = value ? 1 : 0
                  }
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label:
                  _vm.$t("SeaExport.CustomsDeclaration") +
                  _vm.$t("Message.Count")
              }
            },
            [
              _c("el-input-number", {
                attrs: {
                  no: "2",
                  precision: 0,
                  min: 0,
                  max: 999,
                  "controls-position": "right"
                },
                model: {
                  value: _vm.aeJob.csTotal,
                  callback: function($$v) {
                    _vm.$set(_vm.aeJob, "csTotal", $$v)
                  },
                  expression: "aeJob.csTotal"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SeaExport.Inspection") + _vm.$t("Message.Count")
              }
            },
            [
              _c("el-input-number", {
                attrs: {
                  no: "3",
                  precision: 0,
                  min: 0,
                  max: 999,
                  "controls-position": "right"
                },
                model: {
                  value: _vm.aeJob.checkCounts,
                  callback: function($$v) {
                    _vm.$set(_vm.aeJob, "checkCounts", $$v)
                  },
                  expression: "aeJob.checkCounts"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label:
                  _vm.$t("SeaExport.CommodityInspection") +
                  _vm.$t("Message.Count")
              }
            },
            [
              _c("el-input-number", {
                attrs: {
                  no: "4",
                  precision: 0,
                  min: 0,
                  max: 999,
                  "controls-position": "right"
                },
                model: {
                  value: _vm.aeJob.ciCounts,
                  callback: function($$v) {
                    _vm.$set(_vm.aeJob, "ciCounts", $$v)
                  },
                  expression: "aeJob.ciCounts"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("queryJob.guanFeng") + _vm.$t("Message.Count")
              }
            },
            [
              _c("el-input-number", {
                attrs: {
                  no: "5",
                  precision: 0,
                  min: 0,
                  max: 999,
                  "controls-position": "right"
                },
                model: {
                  value: _vm.aeJob.sealCounts,
                  callback: function($$v) {
                    _vm.$set(_vm.aeJob, "sealCounts", $$v)
                  },
                  expression: "aeJob.sealCounts"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("Tool.Authorize") + _vm.$t("Message.Count")
              }
            },
            [
              _c("el-input-number", {
                attrs: {
                  no: "6",
                  precision: 0,
                  min: 0,
                  max: 999,
                  "controls-position": "right"
                },
                model: {
                  value: _vm.aeJob.authorizeCounts,
                  callback: function($$v) {
                    _vm.$set(_vm.aeJob, "authorizeCounts", $$v)
                  },
                  expression: "aeJob.authorizeCounts"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("queryJob.singleCopy") + _vm.$t("Message.Count")
              }
            },
            [
              _c("el-input-number", {
                attrs: {
                  no: "7",
                  precision: 0,
                  min: 0,
                  max: 999,
                  "controls-position": "right"
                },
                model: {
                  value: _vm.aeJob.patchUpCounts,
                  callback: function($$v) {
                    _vm.$set(_vm.aeJob, "patchUpCounts", $$v)
                  },
                  expression: "aeJob.patchUpCounts"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "Submit", type: "primary" },
              on: { click: _vm.clickHandler }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Submit")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "Cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }